import React from "react";
import { SvgIcon } from "@material-ui/core";

const ArchiveIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <path
        d="M2.1875 0.700195H11.8125"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.0625 5.9502V7.7002H3.9375V5.9502"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M0.4375 3.3252H13.5625V12.9502H0.4375V3.3252Z"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export default ArchiveIcon;
